import { z } from "zod";
import { REPORT_SETTING_KEYS } from "@common/helpers/report-settings/report-setting-fields";
import { REPORT_SETTING_SOURCE_KINDS } from "@common/helpers/report-settings/report-setting-source";
import { REPORT_SETTINGS_REPORT_KEYS } from "@common/types/reports/report-settings-report-key";

export const reportSettingsActivityReportKeySchema = z.enum(
    REPORT_SETTINGS_REPORT_KEYS,
);

export const reportSettingsActivitySourceSchema = z
    .object({
        kind: z.enum(REPORT_SETTING_SOURCE_KINDS),
        reportKey: reportSettingsActivityReportKeySchema,
        templateId: z.string().optional(),
        templateName: z.string().optional(),
        organizationId: z.string().optional(),
    })
    .strict();

export const reportSettingsActivityValueSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
]);

export const reportSettingsActivityResolvedSchema = z
    .object({
        value: reportSettingsActivityValueSchema,
        source: reportSettingsActivitySourceSchema,
    })
    .strict();

export const reportSettingsActivityChangeSchema = z
    .object({
        setting: z.enum(REPORT_SETTING_KEYS),
        reportKey: reportSettingsActivityReportKeySchema,
        previous: reportSettingsActivityResolvedSchema,
        next: reportSettingsActivityResolvedSchema,
    })
    .strict();

export const reportSettingsActivityMetadataSchema = z
    .object({
        scope: z.enum(["workspace", "entity"]),
        name: z.string(),
        changes: z.array(reportSettingsActivityChangeSchema),
    })
    .strict();

export const reportTemplateActivityRefSchema =
    reportSettingsActivitySourceSchema.omit({ reportKey: true });

export const reportTemplateActivityMetadataSchema =
    reportSettingsActivityMetadataSchema
        .omit({ changes: true })
        .extend({
            previous: reportTemplateActivityRefSchema,
            next: reportTemplateActivityRefSchema,
        })
        .strict();

export const ReportSettingsUpdateHistoryPresentationSchema =
    reportSettingsActivityMetadataSchema
        .extend({ kind: z.literal("reportSettingsUpdate") })
        .strict();

export const ReportTemplateChangeHistoryPresentationSchema =
    reportTemplateActivityMetadataSchema
        .extend({ kind: z.literal("reportTemplateChange") })
        .strict();

export type ReportSettingsActivityValue = z.infer<
    typeof reportSettingsActivityValueSchema
>;
export type ReportSettingsActivityResolved = z.infer<
    typeof reportSettingsActivityResolvedSchema
>;
export type ReportSettingsActivityChange = z.infer<
    typeof reportSettingsActivityChangeSchema
>;
export type ReportSettingsActivityMetadata = z.infer<
    typeof reportSettingsActivityMetadataSchema
>;
export type ReportTemplateActivityMetadata = z.infer<
    typeof reportTemplateActivityMetadataSchema
>;
